import './NoteGridPanel.scss'
import DataGrid, {Column, Paging} from 'devextreme-react/data-grid';
import {OrderNote} from '../types/OrderNote';
import {formatShortDateShortTime} from '../../../../utils/date-utils';
import {Panel} from '../../../../layouts';

export default function NoteGridPanel(props: { notes: OrderNote[], height?: string | number }) {

	return (
		<Panel header="Notes" className='note-panel'>
			<DataGrid
				className={'grid-with-header'}
				dataSource={props.notes}
				showBorders={true}
				showColumnLines={true}
				columnAutoWidth={true}
				showColumnHeaders={false}
				keyExpr={'noteID'}
				height={props.height}
			>
				<Paging enabled={false} />

				<Column
					dataField={'noteText'}
					caption={'Notes'}
					dataType="string"
					cssClass={'multi-line'}
					allowSorting={false}
					cellRender={(row) => {
						return <div className="note-card">
							<div className="created-by">
								{row.data.createdBy}
							</div>
							<div className='note-text'>
								{row.data.noteText}
							</div>
							<div className='created-on'>
								{formatShortDateShortTime(row.data.createdOn)}
							</div>
							{
								row.data.toEmailAddress &&
								<div className='to-email-address'>
									Emailed to: {row.data.toEmailAddress}
								</div>
							}
						</div>
					}}
				/>
			</DataGrid>
		</Panel>
	)
}
